import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_CONTENT = {
  hero: {
    visible: true,
    badge: "NABH Accredited · Hyderabad",
    heading_line1: "Your health,",
    heading_line2: "one destination.",
    tagline: "Premium care, end-to-end.",
    subtext: "World-class multi-specialty care, 24/7 emergency response, and a team of 120+ specialists — engineered around the patient.",
    image: "https://images.unsplash.com/photo-1586773860418-d37222d8fce3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    search_enabled: true,
    search_placeholder: "Search specialists by name or specialty…",
    emergency_enabled: true, emergency_label: "Emergency",
    book_enabled: true, book_label: "Book Appointment",
    second_opinion_enabled: true, second_opinion_label: "Second Opinion",
    whatsapp_enabled: true, whatsapp_label: "WhatsApp",
    trust_badge_1: "NABH Accredited",
    trust_badge_2: "24×7 Emergency",
    trust_badge_3: "25+ Years",
  },
  stats: {
    visible: true,
    items: [
      { num: "120+", label: "Expert Doctors" },
      { num: "25+", label: "Years" },
      { num: "2.5L+", label: "Patients" },
      { num: "350+", label: "Beds" },
      { num: "22+", label: "Specialties" },
    ],
  },
  about: {
    visible: true,
    eyebrow: "about one hospitals",
    heading: "A new standard of compassionate care.",
    body: "For over two decades, One Hospitals has been a trusted name across South India — combining cutting-edge medical technology, internationally trained specialists, and genuinely compassionate care under one roof.",
    image: "https://images.unsplash.com/photo-1584516150909-c43483ee7932?w=1000",
    rating_value: "4.8/5",
    rating_text: "Average patient rating from 12,400+ verified reviews",
    cta_label: "Discover more",
    cards: [
      { title: "Mission", desc: "World-class care, accessible to all." },
      { title: "Vision", desc: "South India's most trusted partner." },
      { title: "Values", desc: "Empathy. Excellence. Ethics." },
    ],
  },
  specialties_section: { visible: true, eyebrow: "departments", heading: "22+ specialties, one roof.", subtext: "From routine consultations to advanced super-specialty interventions — coordinated, evidence-based, and patient-first." },
  doctors_section: { visible: true, eyebrow: "meet our doctors", heading: "Experienced. Trusted." },
  services_section: { visible: true, eyebrow: "our services", heading: "Care that covers every need." },
  packages_section: { visible: true, eyebrow: "health packages", heading: "Preventive care, priced beautifully." },
  testimonials_section: { visible: true, eyebrow: "patient stories", heading: "Trusted by families." },
  cta_section: { visible: true, eyebrow: "talk to us", heading: "Need expert advice? We're a call away.", subtext: "Our care team is available 24×7. WhatsApp us, book online, or call the helpline.", book_label: "Book Appointment", call_label: "Call Now" },
  floating: { book: true, whatsapp: true, emergency: true },
  nav: {
    about: true, doctors: true, specialties: true, services: true,
    packages: true, insurance: true, schemes: true, resources: true,
    gallery: true, careers: true, contact: true,
    second_opinion_btn: true, book_btn: true,
  },
};

const ContentCtx = createContext(DEFAULT_CONTENT);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  useEffect(() => {
    api.get("/content").then((r) => setContent({ ...DEFAULT_CONTENT, ...r.data })).catch(() => {});
  }, []);
  return <ContentCtx.Provider value={content}>{children}</ContentCtx.Provider>;
}

export const useContent = () => useContext(ContentCtx);
